export function stripHTML(text) {
    var regex = /(<([^>]+)>)/ig;
    return text.replace(regex, "");
  }